import React, { useState } from "react";
import ClaudeChat from "./ClaudeChat";

const TerminalSidebar = ({ isOpen, onClose }) => {
	// Track if component has ever been opened (for lazy initialization)
	const [hasBeenOpened, setHasBeenOpened] = useState(false);

	// Initialize on first open
	if (isOpen && !hasBeenOpened) {
		setHasBeenOpened(true);
	}

	return (
		<>
			{/* Backdrop that dims content behind chat */}
			<div
				className={`chat-backdrop ${isOpen ? "chat-backdrop--visible" : ""}`}
				onClick={onClose}
			/>

			{/* Chat overlay */}
			<div className={`chat-overlay ${isOpen ? "chat-overlay--open" : ""}`}>
				<div className="chat-overlay__header">
					<div className="chat-overlay__title">
						<span className="chat-overlay__icon">◈</span>
						Lazlo
					</div>
					<button className="chat-overlay__close" onClick={onClose} title="Close">
						×
					</button>
				</div>
				{/* Keep mounted once opened, just pass visibility */}
				{hasBeenOpened && <ClaudeChat isVisible={isOpen} />}
			</div>
		</>
	);
};

export default TerminalSidebar;
